<template>
  <div class="contract-page">
    <div class="contract-container">
      <div class="title-bg">估价汇总</div>
      <!-- 搜索区域 -->
      <v-card class="search-card">
        <v-card-text>
          <v-row class="align-center">
            <v-col cols="6" sm="3">
              <v-text-field
                v-model="searchForm.keyword"
                label="关键字搜索"
                persistent-placeholder
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                placeholder="唯一码/项目名称/业务员/估价员"
                @keyup.enter="handleSearch"
                @click:clear="handleSearch"
              />
            </v-col>
            <v-col cols="6" sm="3" style="display: flex; gap: 8px;">
              <v-select
                label="大类"
                persistent-placeholder
                style="width: 100px;"
                v-model="searchForm.bigClass"
                :items="bigClassOptions"
                item-title="title"
                item-value="value"
                variant="outlined"
                density="compact"
                @update:model-value="handleChangeBigClass"
                hide-details
              ></v-select>
              <v-select
                label="小类"
                persistent-placeholder
                style="width: 100px;"
                v-model="searchForm.materialType"
                :items="getMaterialTypeOptions(searchForm.bigClass)"
                item-title="title"
                item-value="value"
                variant="outlined"
                density="compact"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="6" sm="3">
              <div class="d-flex gap-2">
                <v-btn
                  color="primary"
                  variant="flat"
                  density="comfortable"
                  @click="handleSearch"
                  class="search-btn"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  density="comfortable"
                  @click="handleReset"
                  class="search-btn"
                >
                  重置
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 表格区域 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <v-table class="contract-table all-big-table" hover fixed-header>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                  <div class="align-center">
                    {{ header.title }}
                    <!-- <v-menu v-if="header.key === 'priceStatus'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusPricing !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusPricing"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in estStatusListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu> -->
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="text-center">
                <td :colspan="headers.length" class="py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-2">加载中...</div>
                </td>
              </tr>
              <tr v-else-if="contractList.length === 0" class="text-center">
                <td :colspan="headers.length" class="py-8">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in contractList" :key="index">
                  <td class="text-center">{{ item.code || '/' }}</td>
                  <td class="text-center">
                    {{ item.pricingFinishCount }} / {{ item.pricingCount }}
                    <!-- <v-chip
                      :color="getPriceStatusColor(Number(item.priceStatus))"
                      size="small"
                      variant="flat"
                    >
                    {{ getPriceStatusText(Number(item.priceStatus)) }}
                    </v-chip> -->
                  </td>
                  <td class="text-center">{{ item.salesmanName || '/' }}</td>
                  <!-- <td class="text-center">{{ item.customerShortName || '/' }}</td> -->
                  <td class="text-center">{{ item.project || '/' }}</td>
                  <td class="text-center">{{ item.productCount }}</td>
                  <td class="text-center">{{ formatDate(item.toPricingTime) }}</td>
                  <!-- <td class="text-center">{{ formatDate(item.newAddTime) }}</td> -->
                  <td class="text-center">
                    <template v-if="item.pricingClaimList.length > 0">
                      <div v-for="claimItem in item.pricingClaimList" :key="claimItem.id">
                        {{ claimItem.pricingName }}
                      </div>
                    </template>
                    <template v-else>/</template>
                  </td>
                  <!-- <td class="text-center">{{ formatDate(item.pricingTime) }}</td> -->
                  <td class="text-center">
                    <!-- <v-btn
                      color="primary"
                      size="small"
                      variant="flat"
                      class="mr-2"
                      @click="handleSee(item, index)"
                    >
                      查看
                    </v-btn> -->
                    <!-- <v-btn
                      color="primary"
                      size="small"
                      variant="flat"
                      @click="handleEstimate(item, index)"
                      v-if="Number(item.pricingId) === 0 || item.pricingId === null || item.pricingId === undefined"
                    >
                      领取
                    </v-btn> -->
                    <v-btn
                      class="list-edit-btn"
                      @click="handleToEstimate(item)"
                      v-if="item.isPricingClaim"
                    >
                      编辑
                    </v-btn>
                    <v-btn v-else
                      color="primary"
                      size="small"
                      variant="flat"
                      @click="handleEstimate(item, index)"
                    >
                      领取
                    </v-btn>
                    <v-btn
                      class="list-edit-btn"
                      style="margin-left: 8px;"
                      @click="handleToSeeEstimate(item)"
                      v-if="!item.isPricingClaim"
                    >
                      查看
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>

          <!-- 分页区域 -->
          <div class="custom-pagination d-flex align-center justify-space-between">
            <div class="pagination-info">共 {{ total }} 条记录</div>
            
            <div class="d-flex align-center">
              <!-- <span class="items-per-page-text mr-2">每页项目数</span>
              <v-select
                v-model="pageSize"
                :items="[10, 20, 50, 100]"
                variant="outlined"
                density="compact"
                class="d-inline-flex page-size-select mr-4"
                style="width: 80px;"
                hide-details
              /> -->
              
              <div class="pagination-controls">
                <v-btn
                  icon="mdi-chevron-double-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage = 1"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage--"
                  class="pagination-btn"
                />
                <span class="pagination-text mx-2">{{ currentPage }} / {{ totalPages }}</span>
                <v-btn
                  icon="mdi-chevron-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage++"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-double-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage = totalPages"
                  class="pagination-btn"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- 通知弹框 -->
    <NotificationDialog
      v-model="notification.show"
      :type="notification.type"
      :title="notification.title"
      :message="notification.message"
    />

    <!-- 领取确认对话框 -->
    <v-dialog v-model="claimConfirmDialog" max-width="400px">
      <v-card color="#2B2D33">
        <v-card-text class="text-white">
          确定领取当前任务吗？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="claimConfirmDialog = false">取消</v-btn>
          <v-btn 
            color="primary" 
            variant="flat" 
            :loading="claimLoading"
            @click="confirmClaim"
          >
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import DateInput from '@/components/DateInput.vue'
import NotificationDialog from '@/components/NotificationDialog.vue'
import { contractApi } from '@/services/api'
import { contractTypeListOptions,estimateStatusListOptions,estStatusListOptions } from '@/constants/contract'
import { useNotification } from '@/composables/useNotification'
import { materialTypeOptions, getMaterialTypeOptions, bigClassOptions, materialUnitOptions } from '@/constants/contract'

interface Contract {
  id?: number
  contractNo: string
  code: string
  project: string
  partyName: string
  customerShortName: string
  productCount: string
  projectType: string
  salesmanName: string
  priceStatus: string
  region: string
  createTime: string
  toPricingTime: string
  newAddTime: string
  pricingName: string
  pricingClaimList: any[]
  isPricingClaim: boolean
  pricingTime: string
  remarks: string
  pricingId: number
  pricingFinishCount: number
  pricingCount: number
}

interface SearchForm {
  keyword: string
  statusPricing: number | null
  bigClass: string | null
  type: string | null
}

const { showSuccess, showError } = useSnackbar()
const { showSuccessInfo, showErrorInfo,notification } = useNotification()
const router = useRouter()
const userStore = useUserStore()

// 表格列配置
const headers = [
  { title: '合同唯一码', key: 'code', align: 'center',width: '120px' },
  { title: '核价状态', key: 'priceStatus', align: 'center',width: '110px' },
  { title: '业务员', key: 'salesmanName', align: 'center',width: '100px' },
  // { title: '客户简称', key: 'customerShortName', align: 'center',width: '150px' },
  { title: '项目名称', key: 'project', align: 'center',width: '200px' },
  { title: '品项总数', key: 'productCount', align: 'center',width: '60px' },
  // { title: '项目类型', key: 'projectType', align: 'center' },
  // { title: '地区', key: 'region', align: 'center' },
  // { title: '创建时间', key: 'createTime', align: 'center' },
  { title: '转估价时间', key: 'toPricingTime', align: 'center',width: '160px' },
  // { title: '最近更新', key: 'newAddTime', align: 'center',width: '160px' },
  { title: '估价员', key: 'pricingName', align: 'center',width: '90px' },
  // { title: '完成估价时间', key: 'pricingTime', align: 'center',width: '160px' },
  { title: '操作', key: 'actions', align: 'center', sortable: false,width: '100px' }
]

// 响应式数据
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(30)
const total = ref(0)
const contractList = ref<Contract[]>([])
const searchForm = ref<SearchForm>({
  keyword: '',
  statusPricing: null,
  bigClass: null,
  materialType: null
})

// 领取确认相关
const claimConfirmDialog = ref(false)
const claimLoading = ref(false)
const currentClaimItem = ref<Contract | null>(null)
const currentClaimIndex = ref<number>(-1)

// 计算属性
const totalPages = computed(() => Math.ceil(total.value / pageSize.value))

// 方法
const handleChangeBigClass = () => {
  searchForm.value.materialType = null
}

const handleSearch = () => {
  currentPage.value = 1
  loadContractList()
}

const handleReset = () => {
  searchForm.value = {
    keyword: '',
    statusPricing: null,
    bigClass: null,
    materialType: null
  }
  handleSearch()
}

const handleSee = async (item: Contract, index: number) => {
  // router.push({
  //   path: '/estimateNew',
  //   query: {
  //     id: item.id,
  //     mode: 'estimate'
  //   }
  // })
  const url = `/estimateNew?mode=estimate&id=${item.id}`
  window.open(url, '_blank')
}

const handleToEstimate = (item: Contract) => {
  // router.push({
  //   path: '/estimateNew',
  //   query: {
  //     id: item.id,
  //     mode: 'estimate'
  //   }
  // })
  const url = `/estimateNew?mode=estimate&id=${item.id}`
  window.open(url, '_blank')
}


const handleToSeeEstimate = (item: Contract) => {
  const url = `/estimateNew?mode=estimateSee&id=${item.id}`
  window.open(url, '_blank')
}

// 领取
const handleEstimate = async (item: Contract, index: number) => {
  currentClaimItem.value = item
  currentClaimIndex.value = index
  claimConfirmDialog.value = true
}

// 确认领取
const confirmClaim = async () => {
  if (!currentClaimItem.value || currentClaimIndex.value === -1) {
    claimConfirmDialog.value = false
    return
  }

  try {
    claimLoading.value = true
    const res = await contractApi.getPricingClaim(currentClaimItem.value.id!)
    if (res?.code === 0) {
      // showSuccessInfo('请到"我的"页面处理')
      showSuccess('任务领取成功，请到"我的"页面处理')
      claimConfirmDialog.value = false
      contractList.value[currentClaimIndex.value].pricingClaimList.push({
        pricingName: userStore.userInfo?.nickname,
        id: userStore.userInfo?.id
      })
      contractList.value[currentClaimIndex.value].isPricingClaim = true
      // loadContractList()
    } else {
      showError(res?.message || '任务领取失败')
    }
  } catch (error: any) {
    console.error('任务领取失败:', error)
    showError(error.message || '任务领取失败')
  } finally {
    claimLoading.value = false
  }
}

const loadContractList = async () => {
  try {
    loading.value = true
    const res = await contractApi.getPriceList({
      page: currentPage.value,
      pageSize: pageSize.value,
      keyword: searchForm.value.keyword,
      statusPricing: searchForm.value.statusPricing,
      bigClass: searchForm.value.bigClass,
      materialType: searchForm.value.materialType
    })
    
    if (res?.code === 0) {
      contractList.value = res.data.records.map((item: any) => ({
        id: item.id,
        code: item.code,
        contractName: item.projectName,
        customerShortName: item.customerShortName,
        projectType: item.projectType,
        salesmanName: item.salesmanName,
        productCount: item.productCount,
        priceStatus: item.statusPricing,
        region: item.region,
        createTime: item.createTime,
        pricingName: item.pricingName,
        toPricingTime: item.toPricingTime,
        newAddTime: item.newAddTime,
        project: item.project,
        pricingTime: item.pricingTime,
        pricingId: item.pricingId,
        pricingClaimList: item.pricingClaimList,
        pricingFinishCount: item.pricingFinishCount || '-',
        pricingCount: item.pricingCount || '-'
      }))
      for(let i = 0; i < res.data.records.length; i++){
        if(res.data.records[i].pricingClaimList.length > 0){
          for(let j = 0; j < res.data.records[i].pricingClaimList.length; j++){ 
            if(Number(res.data.records[i].pricingClaimList[j].pricingId) === Number(userStore.userInfo?.id)){
              contractList.value[i].isPricingClaim = true
              break
            }
          }
        }
      }
      total.value = res.data.total
    } else {
      showError(res?.message || '获取数据失败')
    }
  } catch (error: any) {
    console.error('获取数据失败:', error)
    showError(error.message || '获取数据失败')
  } finally {
    loading.value = false
  }
}

// 格式化方法
const formatDate = (date: string) => {
  if (!date) return '/'
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

const getPriceStatusColor = (status: number) => {
  const colorMap: Record<number, string> = {
    1: 'status-waiting',
    2: 'status-process',
    3: 'status-success',
  }
  return colorMap[status] || 'status-waiting'
}

const getPriceStatusText = (status: number) => {
  const option = estStatusListOptions.find(opt => opt.value === status)
  return option?.title || '-'
}

// 监听分页变化
watch([currentPage, pageSize], () => {
  window.scrollTo(0, 0)
  loadContractList()
})

// 初始化
onMounted(() => {
  loadContractList()
})
</script>

<style lang="scss" scoped>
.search-input :deep(.mdi-magnify),
.search-input :deep(.mdi-magnify::before),
.search-input :deep(.mdi-close::before),
.search-input :deep(.mdi-close-circle),
.search-input :deep(.mdi-close) {
  color: #fff!important;
}

.contract-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.contract-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.search-card {
  background-color: #2B2D33 !important;
  border: none !important;
  position: relative;
  z-index: 20;
}

.search-card :deep(.v-text-field) .v-field__input,
.search-card :deep(.v-text-field) .v-field__field,
.search-card :deep(.v-text-field) input,
.search-card :deep(.v-autocomplete) .v-field__input,
.search-card :deep(.v-autocomplete) .v-field__field,
.search-card :deep(.v-autocomplete) input,
.search-card :deep(.v-select) .v-field__input,
.search-card :deep(.v-select) .v-field__field,
.search-card :deep(.v-select) input,
.search-card :deep(.v-select) .v-select__selection-text,
.search-card :deep(.v-select) .v-select__selection,
.search-card :deep(.v-text-field) .v-field__append-inner,
.search-card :deep(.v-autocomplete) .v-field__append-inner,
.search-card :deep(.v-select) .v-field__append-inner {
  color: #fff !important;
}

.search-card :deep(.v-text-field) .v-field__outline,
.search-card :deep(.v-autocomplete) .v-field__outline,
.search-card :deep(.v-select) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.search-card :deep(.v-text-field) .v-field__input::placeholder,
.search-card :deep(.v-autocomplete) .v-field__input::placeholder,
.search-card :deep(.v-select) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-card :deep(.v-text-field) .v-label,
.search-card :deep(.v-autocomplete) .v-label,
.search-card :deep(.v-select) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-card :deep(.v-text-field) .v-field__append-inner i,
.search-card :deep(.v-autocomplete) .v-field__append-inner i,
.search-card :deep(.v-select) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.table-card {
  background-color: #2B2D33 !important;
  flex: 1;
  display: flex;
  position: relative;
  z-index: 1;
}

.table-card :deep(.v-card-text) {
  padding: 16px;
}

.table-card :deep(.v-col) {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: center;
}

.table-card .search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 8px;
  min-width: unset;
}

.contract-table{
  background-color: #2B2D33;
}

.contract-table :deep(th) {
  background-color: #2B2D33 !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.contract-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.contract-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.custom-pagination {
  padding: 16px;
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.custom-pagination .pagination-info {
  font-size: 14px;
}

.custom-pagination .items-per-page-text {
  font-size: 14px;
}

.custom-pagination .page-size-select :deep(.v-field__input) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-btn:hover {
  color: #fff !important;
}

.custom-pagination .pagination-btn:disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

.custom-pagination .pagination-text {
  font-size: 14px;
}

.search-input {
  width: 100%;
}

.gap-2 {
  gap: 8px;
}

.search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 16px;
  min-width: unset;
}

/* .delete-dialog {
  background-color: #2B2D33 !important;
}

.delete-dialog :deep(.v-card-title) {
  color: #fff !important;
}

.delete-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-dialog :deep(.v-btn) {
  text-transform: none;
  letter-spacing: 0;
} */

.text-primary {
  color: #D2475D !important;
}

.filter-menu {
  background-color: #2B2D33 !important;
}

.filter-menu :deep(.v-radio-group) {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-menu :deep(.v-radio) {
  min-height: 28px;
  padding: 0;
}

.filter-menu :deep(.v-radio .v-label) {
  font-size: 13px;
  opacity: 0.9;
}

.filter-menu :deep(.v-selection-control) {
  min-height: 28px;
}

.filter-menu :deep(.v-selection-control__wrapper) {
  width: 28px;
  height: 28px;
}

.filter-menu :deep(.v-radio-group .v-selection-control__input > i) {
  color: #D2475D !important;
  font-size: 16px;
}

.filter-menu :deep(.v-radio-group .v-selection-control--dirty .v-selection-control__input > i) {
  opacity: 1;
}

.filter-menu :deep(.v-card-text.pa-2) {
  background-color: #fff !important;
  width: 100px;
}

.bg-status-default{
  border-radius: 4px;
  background-color: #3b3b3b !important;
}

.bg-status-process{
  border-radius: 4px;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;;
}

.bg-status-success{
  border-radius: 4px;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

:deep(th),:deep(td) {
  padding: 0!important;
}
</style> 